/*
 * @Author: changdou.fe@bytedance.com
 * @Date: 2026-03-23 10:58:20
 * @LastEditors: changdou.fe@bytedance.com
 * @LastEditTime: 2026-04-09 13:20:52
 */
import { CircleCheck, CircleX, CircleArrowDown, CircleArrowUp } from 'lucide-react';
import type { UserActivity } from '@/lib/predict-api';

export { useLoadEvents } from './use-load-events';
export type { UseLoadEventsParams, UseLoadEventsReturn } from './use-load-events';

/** 获取活动类型显示信息 */
export function getActivityDisplay(item: UserActivity) {
  const isBuy = item.side === 'BUY';
  const type = item.type?.toUpperCase();

  if (type === 'REDEEM') {
    // 区分亏损（usdcSize=0）和已领取（usdcSize>0）
    const isLoss = item.usdcSize === 0;
    return {
      label: isLoss ? 'predict.portfolio.history.type.loss' : 'predict.portfolio.history.type.redeemed',
      icon: isLoss ? CircleX : CircleCheck,
      iconColor: isLoss ? 'text-red-500' : 'text-amber-500',
      isRedeem: true,
      isLoss,
    };
  }
  if (type === 'DEPOSIT' || type === 'DEPOSITED') {
    return {
      label: 'predict.portfolio.history.type.deposited',
      icon: CircleArrowDown,
      iconColor: 'text-green-500',
      isDeposit: true,
    };
  }
  if (type === 'WITHDRAWAL' || type === 'WITHDRAW' || type === 'WITHDRAWN') {
    return {
      label: 'predict.portfolio.history.type.withdrawn',
      icon: CircleArrowUp,
      iconColor: 'text-red-500',
      isWithdraw: true,
    };
  }
  // 默认为交易
  return {
    label: isBuy ? 'predict.portfolio.history.type.bought' : 'predict.portfolio.history.type.sold',
    icon: CircleCheck,
    iconColor: isBuy ? 'text-green-500' : 'text-red-500',
  };
}

export function formatPredictAmount(item: UserActivity) {
  console.log('item', item);
  const price = item.price || 0;
  const amount = item.amount || 0;
  const isYes = item.outcome === 'Yes';
  // 兼容大小写（后端序列化可能改变 casing）
  const isBuy = item.side?.toUpperCase() === 'BUY';

  // BUY-Market: amount 是 USDC 投入金额，份额 = amount / price
  // SELL-Market: amount 是卖出份额，USDC = amount * price
  const usdcSpent = isBuy ? amount : price * amount;
  const sharesCount = isBuy ? Math.round((amount / price) * 10) / 10 : Math.round(amount * 10) / 10;
  const usdcSize = usdcSpent.toFixed(2);

  const activityDisplay = getActivityDisplay({
    ...item,
    side: isBuy ? 'BUY' : 'SELL',
    usdcSize,
  });
  const ActivityIcon = activityDisplay.icon;
  const isLoss = 'isLoss' in activityDisplay && activityDisplay.isLoss;
  const isDeposit = 'isDeposit' in activityDisplay && activityDisplay.isDeposit;
  const isWithdraw = 'isWithdraw' in activityDisplay && activityDisplay.isWithdraw;

  const valueDisplay = isLoss ? '-' : isDeposit ? `+$${usdcSize}` : isWithdraw ? `-$${usdcSize}` : `${isBuy ? '-' : '+'}$${usdcSize}`;
  const valueColor = isLoss || isWithdraw ? 'text-red-500' : isDeposit ? 'text-green-500' : isBuy ? 'text-font-primary' : 'text-green-500';

  return {
    isYes,
    priceDisplay: (price * 100).toFixed(0),
    usdcSize,
    sharesCount,
    activityDisplay,
    ActivityIcon,
    valueDisplay,
    valueColor,
  };
}

// 格式化分组项标题，去除前缀“分组项标题：”或“分组条目标题："
export const formatGroupItemTitle = (title: string) => {
  if (title.startsWith('分组项标题：')) {
    return title.slice(6);
  } else if (title.startsWith('分组条目标题：')) {
    return title.slice(7);
  }
  return title;
};
